import React, { ComponentPropsWithoutRef, FC } from 'react';
import cx from 'classnames';

import { Check, Cross } from 'components/icons';
import { Override } from 'types/common';

import styles from './styles.module.css';

type ResultIconProps = Override<ComponentPropsWithoutRef<'div'>, {
  type: 'error' | 'success',
}>;

const ResultIcon: FC<ResultIconProps> = ({ className, type }) => (
  <div className={cx(
    styles.root,
    styles[`root_${type}`],
    className,
  )}>
    {type === 'success' ? <Check /> : <Cross />}
  </div>
);

export default ResultIcon;
